export async function getAddressFromPostalCode(postalCode: string): Promise<PostalData[]> {
    if(/^\d{7}$/.test(postalCode)) {
        const response = await fetch(`https://api.kenall.jp/v1/postalcode/${postalCode}`, {
            method: 'GET',
            headers: {
                Authorization: 'Token ' + import.meta.env.VITE_KENALL_API_KEY
            }
        })
        const postalResponse = await response.json();
        return postalResponse?.data ?? [];
    }
    return [];
}

export interface PostalData {
    city: string,
    town: string,
    prefecture: string,
    koaza: string,
}